function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgArttestLogoSingle = function SvgArttestLogoSingle(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 320 86",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.41421
    },
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.33333,0,0,1.33333,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.154072,0,0,-0.145627,56.993,78.9101)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Logo"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Motiv",
    d: "M455.793,226.824C455.793,188.708 424.894,157.81 386.779,157.81C348.664,157.81 317.766,188.708 317.766,226.824C317.766,264.939 348.664,295.838 386.779,295.838C424.894,295.838 455.793,264.939 455.793,226.824M408.945,526.923C319.93,526.923 247.771,423.736 247.771,296.447C247.771,269.454 251.025,243.552 256.988,219.481C265.653,326.116 320.456,408.315 386.779,408.315C459.125,408.315 517.772,310.518 517.772,189.879C517.772,164.443 515.155,140.03 510.362,117.328C546.813,159.583 570.118,224.118 570.118,296.447C570.118,423.736 497.959,526.923 408.945,526.923Z",
    style: {
      fill: "rgb(12,28,51)"
    }
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgArttestLogoSingle, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Arttest-Logo-Single.04e2f742.svg";
export { ForwardRef as ReactComponent };